import React, { useEffect, useState } from 'react';
import './ImageModal.css';

function ImageModal({ isOpen, onClose, images, startIndex = 0 }) {
    const [currentIndex, setCurrentIndex] = useState(startIndex);
    const [loading, setLoading] = useState(true); 

    const currentItem = images[currentIndex];

    const isMedia = currentItem?.type === 'media';
    const isVimeo = currentItem?.type === 'vimeo';
    const isInstagram = currentItem?.type === 'instagram';

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            setCurrentIndex(startIndex);
            setLoading(true);
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen, startIndex]);

    useEffect(() => {
        if (isOpen && isInstagram && window.instgrm) {
            window.instgrm.Embeds.process();
        }
    }, [isOpen, currentIndex, isInstagram]);

    const prevItem = () => {
        setLoading(true);
        setCurrentIndex((currentIndex - 1 + images.length) % images.length);
    };

    const nextItem = () => {
        setLoading(true);
        setCurrentIndex((currentIndex + 1) % images.length);
    };

    if (!isOpen) return null;

    return (
        <div className="imageModalOverlay" onClick={onClose}>
            <div className="imageModalContent" onClick={e => e.stopPropagation()}>
            <button className="modalClose" onClick={onClose}>×</button>

            <div className="modalMediaWrapper">

                {loading && !isVimeo && !isInstagram && (
                <div className="spinner-wrapper">
                    <div className="spinner" />
                </div>
                )}

                {/* IMAGE */}
                {isMedia && currentItem.image && (
                    <img
                        src={currentItem.image}
                        className="modalImage"
                        onLoad={() => setLoading(false)}
                    />
                )}

                {/* VIDEO */}
                {isMedia && currentItem.video && (
                    <video
                        src={currentItem.video}
                        className="modalVideo"
                        controls
                        autoPlay
                        playsInline
                        onLoadedData={() => setLoading(false)}
                    />
                )}


                {/* VIMEO */}
                {isVimeo && (
                    <div className="modalVimeoWrapper">
                        <iframe
                            src={currentItem.src}
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            title="Vimeo Video"
                        ></iframe>
                    </div>
                )}

                {/* INSTAGRAM */}
                {isInstagram && (
                    <div className="modalInstagramWrapper">
                        <blockquote
                            className="instagram-media"
                            data-instgrm-permalink={currentItem}
                            data-instgrm-version="14"
                        />
                    </div>
                )}
                </div>

                {/* ARROWS */}
                {images.length > 1 && (
                    <>
                        <button className="modalArrow left" onClick={prevItem}>&lt;</button>
                        <button className="modalArrow right" onClick={nextItem}>&gt;</button>
                    </>
                )}
            </div>
        </div>
    );
}

export default ImageModal;
